import { Button } from "antd";
import { ButtonProps } from "antd/lib";
import { t } from "i18next";
import React, { useState } from "react";

import { DeleteConfirm } from "../DeleteConfirm";

type PropsDeleteButtonStd = ButtonProps & {
  task: () => Promise<void>;
  content: React.ReactNode;
  successMsg?: string;
};

export const DeleteButtonStd = (props: PropsDeleteButtonStd) => {
  const { task, content, successMsg, ...buttonProps } = props;
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <>
      <Button {...buttonProps} danger onClick={() => setOpen(true)}>
        {t("Delete")}
      </Button>
      <DeleteConfirm
        content={content}
        open={open}
        close={close}
        task={task}
        successMsg={successMsg}
      />
    </>
  );
};
